import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.support, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_NAVIGATION: {
      return {
        ...state,
        navItems: action.navItems,
      };
    }
    case types.SET_DOC_STUDIES: {
      return {
        ...state,
        docStudies: action.studies,
        docInitialStudy: action.studies.length > 0  ? action.studies[0].sl[0] : null,
      };
    }
    default:
      return state;
  }
}
